import Face from "@mui/icons-material/Face";
import { Avatar, CircularProgress, Stack, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectProfile,
  selectProfilePictureBase64,
  selectProfileRole,
} from "../../store/profile/selector";
import { layoutPrivateStyle } from "../../styles/common/sidebar";
import { AdminMenuProps } from "../../shared/Interface/AdminMenuProps";

// eslint-disable-next-line sonarjs/cognitive-complexity
export function UserInfoCard({ modulOpen }: AdminMenuProps) {
  // const [modalChangeRoles, setModalChangeRoles] = useState(false);
  // const activeRole = useSelector(selectProfileActiveRole);
  const [roleName, setRoleName] = useState("");
  const [title, setTitle] = useState("");
  const [businessUnit, setBusinessUnit] = useState("");

  const profileRole = useSelector(selectProfileRole);
  const profile = useSelector(selectProfile);
  const profilePicture = useSelector(selectProfilePictureBase64);

  useEffect(() => {
    const getRole = () => {
      setRoleName(profileRole.name);
      setTitle(profile.title);
      setBusinessUnit(profile.department);
    };

    getRole();
  }, [profile?.businessUnit, profileRole?.name, profile?.title]);
  // const isSmall = useMediaQuery("(min-width: 600px)");

  const sideMenuCardModul =
    // isSmall
    //   ? adminMenu
    //     ? { display: "none" }
    //     : layoutPrivateStyle.cardBox2
    //   :
    !modulOpen
      ? // ? !adminMenu
        layoutPrivateStyle.cardBox2
      : { display: "none" };
  // : adminMenu
  // ? layoutPrivateStyle.cardBox2
  // : { display: "none" };

  const sideMenuCardTitle =
    // isSmall
    //   ? adminMenu
    //     ? { display: "none" }
    //     : { fontSize: "14px" }
    //   :
    !modulOpen
      ? // ? !adminMenu
        { fontSize: "14px" }
      : { display: "none" };
  // : adminMenu
  // ? { fontSize: "14px" }
  // : { display: "none" };

  return (
    <Box sx={layoutPrivateStyle.card}>
      <Box sx={layoutPrivateStyle.cardBox1}>
        <Stack
          direction="row"
          alignItems="center"
          gap="5px"
          sx={{ color: "white" }}
        >
          {!profilePicture ? (
            <Face sx={{ fontSize: "22px" }} />
          ) : (
            <Avatar
              src={profilePicture}
              sx={{
                width: "22px",
                height: "22px",
                objectFit: "cover",
              }}
            />
          )}

          {!profileRole ? (
            <CircularProgress size={15} color="info" />
          ) : (
            <Typography sx={sideMenuCardTitle}>Login as {roleName}</Typography>
          )}
        </Stack>
      </Box>

      <Box sx={sideMenuCardModul}>
        {!profile ? (
          <CircularProgress size={15} color="info" />
        ) : (
          <Typography
            component="span"
            sx={layoutPrivateStyle.cardBoxTypography1}
          >
            {title}
          </Typography>
        )}
        {!profile ? (
          <CircularProgress size={15} color="info" />
        ) : (
          <Typography
            component="span"
            sx={layoutPrivateStyle.cardBoxTypography2}
          >
            {businessUnit}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
